import type { FaireProductEntity } from "../../entity_types/product";

export const p_w3s5zfaud2: FaireProductEntity = {
  token: "p_w3s5zfaud2",
  type: "product",
  name: "Sea Salt Caramels - 2pc Box",
  brandName: "Markham & Fitz Chocolate",
  imageUrl:
    "https://cdn.faire.com/fastly/1b590fbc4d84bff1fe9a0778779d828f4571b1551271ad8339ad48082e2cdcec.jpeg",
  priceDollars: 3.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ac7ad5a87b06de9f8230cb1f07fda5123234958a9201dec0937f44b7e56ac754.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
